import { render, staticRenderFns } from "./SingleSupplier.vue?vue&type=template&id=168fac98&scoped=true&"
import script from "./SingleSupplier.vue?vue&type=script&lang=js&"
export * from "./SingleSupplier.vue?vue&type=script&lang=js&"
import style0 from "./SingleSupplier.vue?vue&type=style&index=0&id=168fac98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168fac98",
  null
  
)

export default component.exports